import React, { useEffect, useRef, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { useFiltersStore } from '../state/filtersStore'
import { useNavigationStore } from '../state/navigationStore'
import { FilterQuestion } from './FilterQuestion'

const FilterPanel = () => {
  const {
    selectedFilter,
    selectedFilterSection,
    appliedFilters,
    addOrUpdateAppliedFilter,
  } = useFiltersStore(
    useShallow((state) => ({
      selectedFilter: state.selectedFilter,
      selectedFilterSection: state.getSelectedFilterSection(),
      appliedFilters: state.appliedFilters,
      addOrUpdateAppliedFilter: state.addOrUpdateAppliedFilter,
    }))
  )

  const { filterPanelOpen, setFilterPanelOpen } = useNavigationStore(
    useShallow((state) => ({
      filterPanelOpen: state.filterPanelOpen,
      setFilterPanelOpen: state.setFilterPanelOpen,
    }))
  )

  const [value, setValue] = useState<boolean | string | undefined>(undefined)
  const [descExpanded, setDescExpanded] = useState(false)

  // Reset local value state when panel is opened
  const prevOpen = useRef(false)

  useEffect(() => {
    // Detect transition from false → true
    if (!prevOpen.current && filterPanelOpen) {
      // Find already applied value for this filter (if any)
      const foundAlreadyAppliedFilter = selectedFilter
        ? appliedFilters.find((f) => f.acf_name === selectedFilter.acf_name)
        : undefined

      setValue(foundAlreadyAppliedFilter?.value ?? undefined)
      setDescExpanded(false)
    }

    prevOpen.current = filterPanelOpen
  }, [filterPanelOpen, selectedFilter, appliedFilters])

  return (
    <div
      className={['filter-panel', filterPanelOpen && 'filter-panel--open'].join(
        ' '
      )}
    >
      {selectedFilter && (
        <>
          <header className='filter-panel__header'>
            {selectedFilterSection && (
              <div className='filter-panel__header-title'>
                <i className={`fa-solid ${selectedFilterSection.icon}`}></i>
                <p>{selectedFilterSection.title}</p>
              </div>
            )}

            <button
              onClick={() => {
                setFilterPanelOpen(false)
              }}
            >
              <i className='fa-solid fa-close'></i>
            </button>
          </header>

          <FilterQuestion
            selectedFilter={selectedFilter}
            value={value}
            setValue={setValue}
            descExpanded={descExpanded}
            setDescExpanded={setDescExpanded}
            onSave={
              value !== undefined
                ? () => {
                    addOrUpdateAppliedFilter(selectedFilter, value)
                    setFilterPanelOpen(false)
                  }
                : undefined
            }
          />
        </>
      )}
    </div>
  )
}

export { FilterPanel }
